import { createSelector } from 'reselect';

const selectLayouts = (state: any) => state.layouts;


export const selectCurrentItem = createSelector([selectLayouts], (layouts) => layouts.current);

export const selectLayoutListItems = createSelector([selectLayouts], (layouts) => layouts.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectLayoutListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLayoutQueryItems = createSelector([selectLayouts], (layouts) => layouts.query);

export const selectCreatedItem = createSelector([selectLayouts], (layouts) => layouts.create);

export const selectUpdatedItem = createSelector([selectLayouts], (layouts) => layouts.update);

export const selectReadItem = createSelector([selectLayouts], (layouts) => layouts.read);

export const selectDeletedItem = createSelector([selectLayouts], (layouts) => layouts.delete);

export const selectSearchedItems = createSelector([selectLayouts], (layouts) => layouts.search);

export const selectItemsCount = createSelector([selectLayouts], (layouts) => layouts.count);

export const selectItemsFilter = createSelector([selectLayouts], (layouts) => layouts.filter);